<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="ch00_fm02"></a><a id="page_1"></a>PIG ISLAND</p>
<hr/>
<p class="textcenterw"><span class="weblink"><a class="nounder" href="http://www.booksattransworld.co.uk" target="_blank">www.booksattransworld.co.uk</a></span></p>
<hr/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?1baaa6f9